import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { ExceptionsDiscountsComponent } from './exceptions-discounts/exceptions-discounts.component';
import { ExceptionsRefundsComponent } from './exceptions-refunds/exceptions-refunds.component';
import { ExceptionsCancelledOrdersComponent } from './exceptions-cancelled-orders/exceptions-cancelled-orders.component';
import { LaborPayrollComponent } from './labor-payroll/labor-payroll.component';
import { LaborCashoutComponent } from './labor-cashout/labor-cashout.component';
import { NgbAccordionModule, NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportsPaginationComponent } from './reports-pagination/reports-pagination.component';
import { CoreModule } from '../core/core.module';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ExceptionsDiscountsComponent,
    ExceptionsRefundsComponent,
    ExceptionsCancelledOrdersComponent,
    LaborPayrollComponent,
    LaborCashoutComponent,
    ReportsPaginationComponent
  ],
  exports: [
    BreadcrumbsComponent,
    ExceptionsDiscountsComponent,
    ExceptionsCancelledOrdersComponent,
    ReportsPaginationComponent,
    ExceptionsRefundsComponent
  ],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAccordionModule,
    NgbDropdownModule,
    CoreModule
  ]
})
export class ComponentsModule { }
